import { JpClassSkillsRatingsDTO } from "../dto/JpClassSkillsRatingsDTO";
import { ClassSkillsRating } from "../models/Classes/ClassSkillsRating";

export const jpClassSkillsRatingsDTOMapper = (
  dto: JpClassSkillsRatingsDTO,
): ClassSkillsRating => {
  return new ClassSkillsRating({
    id: dto.ratingId,
    skillId: dto.skillId,
    name: dto.ratingName,
    sequence: dto.ratingSeq,
  });
};
